/**
 * 防抖
 * 持续事件结束后再调用业务函数
 * @param {(...rest: any[]) => void} fn 业务函数
 * @param delay 防抖等待时长
 * @param [immediate] 调用之后是否立即执行一次函数
 * @returns {(...rest: any[]) => void}
 */
function debounce(fn, delay, immediate) {
    let delayTimer = null;
    let args;
    let timestamp = 0;
    const later = () => {
        const last = +new Date() - timestamp;
        if (last < delay && last >= 0) {
            delayTimer && clearTimeout(delayTimer);
            delayTimer = setTimeout(later, delay - last);
            return;
        }
        delayTimer && clearTimeout(delayTimer);
        delayTimer = null;
        if (!immediate)
            fn(...args);
    };
    return (...rest) => {
        args = rest;
        timestamp = +new Date();
        const callImmediate = immediate && !delayTimer;
        if (delayTimer === null) {
            delayTimer = setTimeout(later, delay);
        }
        if (callImmediate)
            fn(...args);
    };
}
export default debounce;
//# sourceMappingURL=debounce.js.map